// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel_303a1ce6 {
  position: relative;
}
.carousel__viewport_303a1ce6 {
  box-sizing: border-box;
  overflow: hidden;
}
.carousel__list_303a1ce6 {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
}
.carousel__prev_303a1ce6 {
  left: 0;
  margin-right: 2px;
}
.carousel__prev_303a1ce6.icon-button {
  color: #11304d;
  top: 0;
  bottom: 0;
  width: 24px;
  position: absolute;
  z-index: 10;
  background-color: #dce1e5;
  opacity: 0.8;
}
.carousel__prev_303a1ce6.icon-button:disabled {
  visibility: hidden;
  cursor: default;
}
.carousel__next_303a1ce6 {
  right: 0;
  margin-left: 2px;
}
.carousel__next_303a1ce6.icon-button {
  color: #11304d;
  top: 0;
  bottom: 0;
  width: 24px;
  position: absolute;
  z-index: 10;
  background-color: #dce1e5;
  opacity: 0.8;
}
.carousel__next_303a1ce6.icon-button:disabled {
  visibility: hidden;
  cursor: default;
}
.carousel_303a1ce6:hover .carousel__list_303a1ce6 {
  will-change: left;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carousel": `carousel_303a1ce6`,
	"carousel__viewport": `carousel__viewport_303a1ce6`,
	"carousel__list": `carousel__list_303a1ce6`,
	"carousel__prev": `carousel__prev_303a1ce6`,
	"carousel__next": `carousel__next_303a1ce6`
};
export default ___CSS_LOADER_EXPORT___;
